import React from 'react'

const Q2SizingRecommendationRow = ({ label, value, unit }) => {
  return (
    <tr>
      <td>{label}</td>
      <td style={{ textAlign: 'right' }}>
        {value} {unit || 'cm.'}
      </td>
    </tr>
  )
}

export default Q2SizingRecommendationRow
